import React, { CSSProperties } from "react";
import BreadcrumbAndTitle from "@components/BreadcrumbAndTitle";
import { BreadcrumbChild } from "@components/BreadcrumbCustom";
import Layout from "@components/Layout";
import ROUTES from "@config/routes";
import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { FilterButton } from "./shared/FilterButton";
import { MyDriversTable } from "./shared/MyDriversTable";
import { MyDriversProvider } from "@context/MyDriversContext/provider";
import { DownloadButton } from "./shared/DownloadButton";

const Container: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const styles = useStyles(isMobile);

  const breadcrumbDataOrders: BreadcrumbChild[] = [
    {
      link: ROUTES.USER_ROUTES.HOME,
      label: "Início",
    },
    {
      label: "Meus motoristas",
    },
  ];

  return (
    <Layout disableToolbarCNPJ disableToolbarNotifications>
      <Box style={styles.root}>
        <Stack sx={styles.header}>
          <BreadcrumbAndTitle
            breadcrumbData={breadcrumbDataOrders}
            title={String(breadcrumbDataOrders[1].label)}
          />
        </Stack>

        <Stack sx={styles.shortcut_content}>
          <Stack
            sx={{
              flexDirection: isMobile ? "column" : "row",
              gap: "1rem",
              width: "100%",
            }}
          >
            <DownloadButton />
            <FilterButton />
          </Stack>
        </Stack>

        <MyDriversTable />
      </Box>
    </Layout>
  );
};

const MyDrivers: React.FC = () => {
  return (
    <MyDriversProvider>
      <Container />
    </MyDriversProvider>
  );
};

const useStyles = (isMobile?: boolean): Record<string, CSSProperties> => ({
  root: {
    display: "flex",
    flexDirection: "column",
    margin: isMobile ? 0 : "0 4rem",
    width: isMobile ? "100%" : "auto",
    padding: isMobile ? "2rem" : "1rem",
  },
  header: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  shortcut_content: {
    flexDirection: "row",
    justifyContent: isMobile ? "stretch" : "flex-end",
    alignItems: "center",
    width: "100%",
  },
});

export default MyDrivers;
